import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=74c060cc&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=ts"
export * from "./orderDetail.vue?vue&type=script&lang=ts"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=74c060cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c060cc",
  null
  
)

export default component.exports